document.addEventListener("DOMContentLoaded", () => {
  const seriesPerson = Array.from(document.querySelectorAll('.row-series-person'));

  if(seriesPerson) {
    seriesPerson.map(series => {
      const blurb = series.querySelector('.et_pb_blurb_content');
  
      blurb.addEventListener('click', (e) => {
        console.log(e.target);
        series.classList.toggle('open');
      });
    });
  }
  
});


// WEBPACK FOOTER //
// ./src/js/pages/creators.js